import {ResizeObserverMessage, SetResizeObserverMessage} from '../../messages'
import {MyopMessages} from "../../common/MyopMessages";
import {BaseMessageHandler} from "../../common";

export class SetResizeObserverHandler extends BaseMessageHandler<SetResizeObserverMessage> {
    messageType = MyopMessages.SetResizeObserverMessage

    executor = (event: SetResizeObserverMessage) => {
        const resizeObserver = new ResizeObserver((entries) => {
            //TODO : pass the height
            this.messageToHost(new ResizeObserverMessage());
        });
        resizeObserver.observe(document.body);

        return () => {
            resizeObserver.disconnect()
        }
    }
}
